import { render, staticRenderFns } from "./CopiarCardapioPdv.vue?vue&type=template&id=c551c9a2"
import script from "./CopiarCardapioPdv.vue?vue&type=script&lang=js"
export * from "./CopiarCardapioPdv.vue?vue&type=script&lang=js"
import style0 from "./CopiarCardapioPdv.vue?vue&type=style&index=0&id=c551c9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports